<template>
  <div>
    <Divider class="col-span-3" />

    <h2>{{ t('blockManually') }}</h2>

    <p class="mb-3 mt-4">
      <span class="">
        {{ t('typeInBookingNumber') }}:
        <span class="font-medium">{{ booking.bookingNumber }}</span>
      </span>
    </p>
    <Checkbox v-model="confirmManualReservation">
      <span
        >{{ t('confirmManualReservation1') }}
        <span class="font-medium">(<span v-currency="amount" />)</span>
        {{ t('confirmManualReservation2') }}</span
      >
    </Checkbox>
    <div class="mt-5 flex justify-end">
      <ButtonNext
        :is-loading="isSaving"
        :disabled="!confirmManualReservation"
        type="submit"
        @click.prevent="$emit('continueWithoutTransaction')"
      >
        {{ t('continueWithManualPayment') }}
      </ButtonNext>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonNext from '@/components/buttons/ButtonNext.vue';
import type { Booking } from '@/entities/bookings/booking.entity';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import Checkbox from '@/components/Checkbox.vue';

defineProps<{
  booking: Booking;
  amount: number;
  isSaving: boolean;
}>();

defineEmits<{
  (e: 'continueWithoutTransaction'): void;
}>();

const { t } = useI18n();

const confirmManualReservation = ref(false);
</script>

<i18n lang="json">
{
  "en": {
    "blockManually": "Special case deposit",
    "confirmManualReservation1": "Confirm reservation of deposit via credit card in the amount of reservation amount",
    "confirmManualReservation2": ".",
    "continueWithManualPayment": "Continue with manual payment",
    "typeInBookingNumber": "Please enter booking number into card terminal"
  },
  "de": {
    "blockManually": "Sonderfall Kaution",
    "confirmManualReservation1": "Reservierung der Kaution über Kreditkarte i.H.v. Reservierungsbetrag",
    "confirmManualReservation2": "bestätigen.",
    "continueWithManualPayment": "Weiter mit manueller Zahlung",
    "typeInBookingNumber": "Buchungsnummer bitte ins Kartenterminal eingeben"
  },
  "es": {
    "blockManually": "Caso especial: fianza",
    "confirmManualReservation1": "Confirmar la reserva de la fianza con tarjeta de crédito por el importe de la reserva",
    "confirmManualReservation2": ".",
    "continueWithManualPayment": "Continuar con el pago manual",
    "typeInBookingNumber": "Introduzca el número de reserva en el terminal de tarjeta"
  }
}
</i18n>
